module.exports = __webpack_public_path__ + "static/media/disconnect_device.e2b070ee.svg";